module.exports = __webpack_public_path__ + "img/sand-decal-08.ea0255b4.png";